import {EntityService} from 'src/service/EntityService';

export class AgreementService extends EntityService {

  static entity = 'iam-agreement';

  static update(id: string, data: any): Promise<any> {
    return this.axios.post(`${this.entity}/${id}/update`, data).then(res => res.data);
  }

  static uploadPDFFile(agreementId: string, data: any): Promise<any> {
    return this.axios.post(`${this.entity}/${agreementId}/pdf`, data).then(res => res.data);
  }

  static uploadDraft(data: any): Promise<any> {
    return this.axios.post(`${this.entity}/upload-draft`, data).then(res => res.data);
  }

  static sentEmailNotifyBuyer(agreementId: string, data: any): Promise<any> {
    return this.axios.put(`${this.entity}/${agreementId}/sent-email-notify-buyer`, data).then(res => res.data);
  }

  static agreementSequence(templateAgreementId: string): Promise<any> {
    return this.axios.get(`${this.entity}/agreement-sequence?templateAgreementId=${templateAgreementId}`).then(res => res.data);
  }

  static fillPlaceholder(data: any): Promise<any> {
    return this.axios.put(`/iam-main/template-agreements/fill-placeholder`, data).then(res => res.data);
  }

  static cancelAgreement(agreementId: string, data: any): Promise<any> {
    return this.axios.put(`${this.entity}/${agreementId}/cancel`, data).then(res => res.data);
  }

  static convertToDraft(agreementId: string): Promise<any> {
    return this.axios.put(`${this.entity}/${agreementId}/convert-to-draft`).then(res => res.data);
  }

  static getHeaderInfo(code: string): Promise<any> {
    return this.axios.get(`${this.entity}/header-info`, {params: {code}}).then(res => res.data);
  }

  static getAgreementFiles(agreementId: string): Promise<any> {
    return this.axios.get(`${this.entity}/${agreementId}/files`).then(res => res.data);
  }

  static getAgreementInfo(agreementId: string): Promise<any> {
    return this.axios.get(`${this.entity}/${agreementId}/info`).then(res => res.data);
  }

  static updateAgreementFiles(agreementId: string, data: any): Promise<any> {
    return this.axios.put(`${this.entity}/${agreementId}/files`, data).then(res => res.data);
  }

    static unsignedParties(agreementId: string): Promise<any> {
    return this.axios.get(`${this.entity}/${agreementId}/unsigned-parties`).then(res => res.data);
  }

  static uploadSignedFile(agreementId: string, partyId: string, signedPdfBase64: string): Promise<any> {
    const formData = new FormData();
    
    const byteCharacters = atob(signedPdfBase64);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'application/pdf' });
    
    const file = new File([blob], `signed_${agreementId}_${partyId}.pdf`, { type: 'application/pdf' });
    formData.append('contentFile', file);
    formData.append('signatureData', JSON.stringify([{
      partyId: partyId,
      roleTypeId: 'BuyerSignedExec',
      isSigned: 'Y',
      signedDate: Date.now(),
      description: 'Đã ký số thành công'
    }]));

    return this.axios.post(`${this.entity}/${agreementId}/pdf`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }).then(res => res.data);
  }

  static pullSigningData(data: {
    agreementId: string;
    partyId: string;
    roleTypeId: string;
    referenceNumber?: string;
    signingSecretCode?: string;
  }): Promise<{
    base64FileData: string;
    signatureLocationList: Array<{ locationSeqId: string; x: number; y: number; width: number; height: number; page: number; fontSize: number; name: string; }>;
    signingDate: string;
    partyIdValue?: string;
    checkSubjectUid?: string;
    fileName?: string;
    errors?: any;
  }> {
    try {
      if (typeof document !== 'undefined' && document.cookie) {
        const cookiePairs = document.cookie.split(';');
        const hostname = window.location.hostname;
        const domainParts = hostname.split('.');
        const domainsToClear: string[] = [];
        domainsToClear.push(hostname);
        if (domainParts.length > 1) {
          domainsToClear.push('.' + domainParts.slice(-2).join('.'));
        }
        cookiePairs.forEach(pair => {
          const name = pair.split('=')[0]?.trim();
          if (!name) return;
          ['/', ''].forEach(path => {
            domainsToClear.forEach(domain => {
              document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=${path || '/'}; domain=${domain}`;
            });
          });
          document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
        });
      }
    } catch (e) {
    }
    return this.axios.put(`${this.entity}/pull-data`, data)
      .then(res => res.data)
      .then((resp: any) => {
        const defaultFontSize = 10;
        const list = Array.isArray(resp?.signatureLocationList) ? resp.signatureLocationList : [];
        resp.signatureLocationList = list.map((b: any, idx: number) => {
          const locationSeqId = String(b?.locationSeqId ?? idx + 1);
          const pageNumber = Number(b?.pageNumber ?? 1);
          const llx = Number(b?.llx ?? 0);
          const lly = Number(b?.lly ?? 0);
          const widthPx = Number(b?.widthPx ?? 0);
          const heightPx = Number(b?.heightPx ?? 0);
          const pageWidth = Number(b?.pageWidth ?? 0);
          const pageHeight = Number(b?.pageHeight ?? 0);
          const fontSize = Number(b?.fontSize ?? defaultFontSize);
          const name = String(b?.name ?? `SignatureId${locationSeqId}`);
          const roleTypeId = String(b?.roleTypeId ?? '');

          return {
            locationSeqId,
            name,
            fontSize,
            pageNumber,
            widthPx,
            heightPx,
            llx,
            lly,
            pageWidth,
            pageHeight,
            page: pageNumber,
            x: llx,
            y: lly,
            width: widthPx,
            height: heightPx,
            roleTypeId, 
          };
        });
        return resp;
      });
  }
  static pushSignedData(params: {
    signedBy: string;
    base64FileData: string;
    agreementId?: string;
    partyId?: string;
    roleTypeId: string;
    referenceNumber?: string | null;
    signingSecretCode?: string;
  }): Promise<any> {
    return this.axios.post(`${this.entity}/push-data`, params).then(res => res.data);
  }

  static updateSigningError(params: {
    agreementId?: string;
    partyId?: string;
    roleTypeId?: string;
    referenceNumber?: string;
    signingSecretCode?: string;
  }): Promise<any> {
    return this.axios.put(`${this.entity}/update-signing-error`, params).then(res => res.data);
  }
  static getDetail(agreementId: string): Promise<any> {
    return this.axios.get(`${this.entity}/${agreementId}/detail`).then(res => res.data);
  }
  static saveFile(fileId: string , fileName: string): Promise<any> {
    return this.axios.put(`${this.entity}/document-name`, { fileId, fileName }).then(res => res.data);
  }
  static openContent(agreementId: string, fileId: string): Promise<any> {
    return this.axios.post(`${this.entity}/open-content`, {
      agreementId,
      fileId
    }).then(res => res.data);
  }
  static closeContent(agreementId: string, fileId: string): Promise<any> {
    return this.axios.post(`${this.entity}/close-content`, {
      agreementId,
      fileId
    }).then(res => res.data);
  }
  static uploadFile(file: File, agreementId: string, isMainFile: 'Y' | 'N' = 'N', sequenceNum?: number | null): Promise<any> {
    const formData = new FormData();
    formData.append('contentFile', file);
    formData.append('agreementId', agreementId);
    formData.append('isMainFile', isMainFile);
    if (sequenceNum !== undefined && sequenceNum !== null) {
      formData.append('sequenceNum', String(sequenceNum));
    }
    
    return this.axios.post(`${this.entity}/upload`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }).then(res => res.data);
  }
  static generateDocumentCode(agreementConfigureEnumId: string): Promise<any> {
    return this.axios.get(`${this.entity}/agreementNo`, { params: { agreementConfigureEnumId } }).then(res => res.data);
  }
  static saveSignaturePositions(agreementId: string, data: any): Promise<any> {
    return this.axios.put(`${this.entity}/${agreementId}`, data).then(res => res.data);
  }
  static getAgreementList(lazyLoadEvent: any ,agreementType?: string | Array<string>): Promise<any> {
    return this.axios.get(`${this.entity}/agreements`, {params: {lazyLoadEvent, agreementType}}).then(res => res.data);
  }
  static deleteAgreementContent(agreementId: string, fileId: string): Promise<any> {
    return this.axios.delete(`${this.entity}/${agreementId}/content`, { params: { fileId } }).then(res => res.data);
  }
  static moveToTrash(agreementId: string): Promise<any> {
    return this.axios.put(`${this.entity}/${agreementId}/trash`).then(res => res.data);
  }
  static restoreAgreement(agreementId: string): Promise<any> {
    return this.axios.put(`${this.entity}/${agreementId}/restore`).then(res => res.data);
  }
  static signAgreement(agreementId: string): Promise<any> {
    return this.axios.put(`${this.entity}/${agreementId}/sign`).then(res => res.data);
  }
  static getAgreementSignings(lazyLoadEvent: any): Promise<any> {
    const params = {
      lazyLoadEvent: typeof lazyLoadEvent === 'string' ? lazyLoadEvent : JSON.stringify(lazyLoadEvent)
    };
    return this.axios.get(`${this.entity}/agreement-signing`, { params }).then(res => res.data);
  }
}